<template>

            <svg class="bar-chart" :width="width" :height="height" :viewBox="'0 0 '+width+' '+height">
                <g v-for="d in data" v-tooltip :title="d[dimension] + ' - ' + numeral(d[metric]).format(numeralFormat)" style="cursor: pointer;">
                    <!--<title>{{d[dimension]}} - {{d[metric]}}</title>-->
                    <rect :x="x(d[dimension])" :width="x.bandwidth()" :y="y(d[metric])" :height="height - y(d[metric])" :fill="color(d[dimension])"></rect>
                </g>
            </svg>

</template>
<script>
    import * as d3 from 'd3';
    import _ from 'lodash';
    import Tooltip from '../../Directives/Tooltip';
    import numeral from 'numeral';

    export default {
        data: function(){
            return {

            }
        },
        props:{
            data: {},
            width: {default: 755},
            height: {default: 500},
            dimension: {},
            metric: {},
            color: {},
            yDomain: {},
            numeralFormat: {}
        },
        directives:{
            Tooltip
        },
        methods:{
            numeral
        },
        computed:{
            x: function(){
                return d3.scaleBand()
                    .padding(0.2)
                    .range([0, this.width])
                    .domain(_(this.data).map((d)=>{return d[this.dimension]}).value());
            },
            y: function(){
                return d3.scaleLinear()
                    .range([this.height, 0])
                    .domain(this.yDomain || [0, d3.max(this.data, (d) => {return 1 * d[this.metric]})]);
            }
        }
    }
</script>


// WEBPACK FOOTER //
// src/js/Components/Charts/BarChart.vue